<script lang="ts">
  import { badgeImage, constBadgeTitles } from "$app/utils"

  let props = $props()

  let {
    memberBadges
  }: {
    memberBadges: BadgeType[]
  } = props

  import badgePNG from "@images/accomplishments/badge.png"
</script>

{#if memberBadges?.length > 0}
  <div
    class="bg-amber-100 p-8 grid grid-cols-1 mb-4 border border-gray-200 rounded-lg shadow-lg mt-4"
  >
    <div class="flex justify-center items-center">
      <img src={badgePNG} class="size-10 mr-3" alt="Member Badges" />
      <p class="text-2xl font-bold text-orange-800 text-center">
        The following team members earned badges this week!
      </p>
    </div>

    <ul class="grid grid-cols-1 md:grid-cols-4 gap-6 mt-8">
      {#each memberBadges as memberBadge (memberBadge.name)}
        {@const badge = memberBadge.badges.at(-1)}
        <li
          class="flex justify-center items-center flex-col bg-amber-50 py-3 px-2 rounded-sm shadow"
        >
          <img
            class="mx-auto size-12 rounded-full"
            src={memberBadge.avatar_url}
            alt=""
          />
          <p class="mt-1 text-sm tracking-tight text-gray-900">
            {memberBadge.user_name}
          </p>
          <p
            class="mt-1 text-base italic font-semibold tracking-tight text-amber-900 text-center"
          >
            EARNED
          </p>

          {#if badge.level && badge.level > 0}
            <img
              src={badgeImage(badge.name, badge.level)}
              alt="{constBadgeTitles[badge.name]} Badge"
              class="size-24"
            />
            <h3
              class="mt-1 text-sm font-bold tracking-tight text-gray-900 text-center"
            >
              {constBadgeTitles[badge.name]} - Level {badge.level}
            </h3>
          {:else}
            <img
              src={badgeImage(badge.name)}
              alt="{constBadgeTitles[badge.name]} Badge"
              class="size-24"
            />
            <h3
              class="mt-1 text-sm font-bold tracking-tight text-gray-900 text-center"
            >
              {constBadgeTitles[badge.name]}
            </h3>
          {/if}
        </li>
      {/each}
    </ul>
  </div>
{/if}
